import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Tag({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Tag</title>
      <path
        d="M3.58579 12.5858L4.11612 12.0555L3.58579 12.5858ZM15.1213 19.8787L14.591 19.3484L15.1213 19.8787ZM19.8787 15.1213L19.3483 14.591L19.8787 15.1213ZM12.5858 3.58579L12.0555 4.11612L12.5858 3.58579ZM5 3.75H11.1716V2.25H5V3.75ZM12.0555 4.11612L19.3484 11.409L20.409 10.3484L13.1161 3.05546L12.0555 4.11612ZM19.3483 14.591L14.591 19.3484L15.6516 20.409L20.409 15.6517L19.3483 14.591ZM11.409 19.3483L4.11612 12.0555L3.05546 13.1161L10.3483 20.409L11.409 19.3483ZM3.75 11.1716V5H2.25V11.1716H3.75ZM4.11612 12.0555C3.8817 11.821 3.75 11.5031 3.75 11.1716H2.25C2.25 11.9009 2.53973 12.6004 3.05546 13.1161L4.11612 12.0555ZM14.591 19.3484C13.7123 20.227 12.2877 20.227 11.409 19.3483L10.3483 20.409C11.8128 21.8735 14.1872 21.8735 15.6516 20.409L14.591 19.3484ZM19.3484 11.409C20.227 12.2877 20.227 13.7123 19.3483 14.591L20.409 15.6517C21.8735 14.1872 21.8735 11.8128 20.409 10.3484L19.3484 11.409ZM11.1716 3.75C11.5031 3.75 11.821 3.8817 12.0555 4.11612L13.1161 3.05546C12.6004 2.53973 11.9009 2.25 11.1716 2.25V3.75ZM5 2.25C3.48122 2.25 2.25 3.48122 2.25 5H3.75C3.75 4.30964 4.30964 3.75 5 3.75V2.25Z"
        fill={color ?? 'currentColor'}
      />
      <circle cx="7.5" cy="7.5" r="1.5" fill={color ?? 'currentColor'} />
    </svg>
  );
}
